import searchStore, { defaultSearchStore } from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Called when user exits from the search.
 * Reset the view state related properties
 */
export default select({
    searchStore: function () { return searchStore; },
})(action('resetSearchViewState')(function resetSearchViewState(state) {
    resetSearchInputState(state);
    state.searchStore.previousNode = defaultSearchStore.previousNode;
    state.searchStore.searchTextForSuggestion = defaultSearchStore.searchTextForSuggestion;
    state.searchStore.selectedSuggestionIndex = defaultSearchStore.selectedSuggestionIndex;
}));
/**
 * Reset the search input related properties
 */
export var resetSearchInputState = select({
    searchStore: function () { return searchStore; },
})(action('resetSearchInputState')(function resetSearchInputState(state) {
    state.searchStore.suggestionSegments = [];
    state.searchStore.suggestionPillIds = [];
    state.searchStore.suggestionPills.clear();
    state.searchStore.searchText = defaultSearchStore.searchText;
}));
//# sourceMappingURL=resetSearchViewState.js.map